(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  if (!window.__mcCartLayerSyncInstalled) {
    window.__mcCartLayerSyncInstalled = true;

    const syncCartLayer = () => {
      const drawer = document.getElementById('mini-cart');
      document.documentElement.classList.toggle(
        'mc-cart-layer-active',
        Boolean(drawer && drawer.hasAttribute('open'))
      );
    };

    const cartLayerObserver = new MutationObserver(syncCartLayer);
    cartLayerObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['open'],
      childList: true,
      subtree: true,
    });

    syncCartLayer();
  }

  } catch(e) { console.error(e); }
})();
})();
